"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SecurityContextLogoutHandler = void 0;
var _axios = _interopRequireDefault(require("axios"));
var _core = require("core.ui-module_site-components");
var _ApplicationContext = require("./ApplicationContext");
var _SecurityContextHolder = require("./SecurityContextHolder");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// eslint-disable-next-line import/prefer-default-export
class SecurityContextLogoutHandler {
  static logout(securityContext) {
    const currentContext = securityContext || _SecurityContextHolder.SecurityContextHolder.getCurrentContext();
    try {
      // Directly using axios to avoid a race condition with SecureClient axios-interceptors and a call to SecureContextHolder.reset()
      // Do nothing on failures, so 
      _axios.default.post(`${_ApplicationContext.ApplicationContext.getApiBasePath()}/security/authn/logout`, undefined, {
        headers: {
          Authorization: `Bearer ${currentContext.tokenId}`
        }
      }).catch(() => {
        // Gobble gobble
      });
    } catch (err) {
      // Gobble gobble
    }
    _SecurityContextHolder.SecurityContextHolder.reset();
    _ApplicationContext.ApplicationContext.clearContext();
    _core.PostMessage.postMessageCoreClose('Logout', {});
  }
}
exports.SecurityContextLogoutHandler = SecurityContextLogoutHandler;
//# sourceMappingURL=SecurityContextLogoutHandler.js.map